import { render, staticRenderFns } from "./CompensationProcedures.vue?vue&type=template&id=e6ab5052&scoped=true"
import script from "./CompensationProcedures.vue?vue&type=script&lang=js"
export * from "./CompensationProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ab5052",
  null
  
)

export default component.exports